import styled from 'styled-components';
import { toRem } from './Utils';

export type BoxProps = {
    flex?: boolean | 'row' | 'column',
    alignCenter?: boolean,
    justifyCenter?: boolean,
    width?: number | string | null,
    height?: number | string | null,
    minWidth?: number | string | null,
    minHeight?: number | string | null,
    padding?: number | string | null,
    margin?: number | string | null,
};

export const Box = styled.div<BoxProps>`
    display: ${p => !!p.flex ? 'flex' : 'block'};
    flex-direction: ${p => p.flex === 'column' ? 'column' : 'initial'};
    ${p => !!p.alignCenter ? 'align-items: center' : ''};
    ${p => !!p.justifyCenter ? 'justify-content: center' : ''};
    ${p => !!p.flex ? 'flex' : 'block'};
    width: ${p => toRem(p.width)};
    height: ${p => toRem(p.height)};
    min-width: ${p => toRem(p.minWidth)};
    min-height: ${p => toRem(p.minHeight)};
    padding: ${p => toRem(p.padding)};
    margin: ${p => toRem(p.margin)};
`;
